import { DockOverview } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class DockItemSetId {
  public static readonly type = '[DockItem] Set Id';

  constructor(public payload: number) {}
}

export class DockItemCreate {
  public static readonly type = '[DockItem] Create Dock';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockOverview: DockOverview;
    },
  ) {}
}

export class DockItemUpdate {
  public static readonly type = '[DockItem] Update Dock';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockOverview: DockOverview;
    },
  ) {}
}

export class DockItemLoadQr {
  public static readonly type = '[DockItem] Load QR';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockId: number;
    },
  ) {}
}

export class DockItemDelete {
  public static readonly type = '[DockItem] Delete Dock';

  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockIds: number[];
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      listRefreshNeeded?: boolean;
    },
  ) {}
}

export class DockItemQrInitialState {
  public static readonly type = '[DockItem] QR set initial state';
}

export class DockItemInitialState {
  public static readonly type = '[DockItem] Set initial state';
}
